interface PageSEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  schema?: Record<string, unknown>[];
}

export function PageSEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  schema = [],
}: PageSEOProps) {
  const fullTitle = `${title} - 一起草`;
  const ogTitleFinal = ogTitle || fullTitle;
  const ogDescFinal = ogDescription || description;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`https://cswan771.cn${canonicalUrl}`} />
      <meta property="og:title" content={ogTitleFinal} />
      <meta property="og:description" content={ogDescFinal} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={`https://cswan771.cn${canonicalUrl}`} />
      <meta name="twitter:title" content={ogTitleFinal} />
      <meta name="twitter:description" content={ogDescFinal} />
      {schema.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </>
  );
}